import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { JgPhysicalInspUnitItemBatchRequest } from '../models/jg/jg-physical-insp-unit-item-batch-request.model';
import { JgPhysicalInspUnitItemBatchResponse } from '../models/jg/jg-physical-insp-unit-item-batch-response.model';
import { JgPhysicalInspUnit } from '../models/jg/jg-physical-insp-unit.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class JgPhysicalInspUnitService extends RequestService<JgPhysicalInspUnit> {
  static PATH = '/jg/physicalInsp/unit';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(httpClient, JgPhysicalInspUnitService.PATH, globalService.debugUrl);
  }

  batchInsp(req: JgPhysicalInspUnitItemBatchRequest) {
    return this.httpClient.post<JgPhysicalInspUnitItemBatchResponse[]>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${JgPhysicalInspUnitService.PATH}/batchInsp`,
      req,
    );
  }
}
